import {TranslateService} from '@ngx-translate/core';
import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {FileService, HttpLoaderService} from '@tymes4-shared';
import {ConversionHelper} from 'app/shared/helpers/conversion-helper';
import {SeatPlanHelper} from 'app/shared/helpers/seatplan-helper';
import {SeatplanLegendComponent} from 'app/shared/dialogs/seatplan-legend/seatplan-legend.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ContingentModel, ContingentService, EventPlacementService, SectionAvailabilityArgs} from '../../api';
import * as jqModule from 'jquery';
import 'jquery.panzoom/dist/jquery.panzoom';
import 'jquery-mousewheel/jquery.mousewheel';

declare const $: JQueryStatic;

// Bridge: copy panzoom plugin from bundled jQuery to global jQuery
const _jq = jqModule as any;
if (typeof ($ as any).fn?.panzoom !== 'function' && typeof _jq.fn?.panzoom === 'function') {
  ($ as any).fn.panzoom = _jq.fn.panzoom;
  ($ as any).Panzoom = _jq.Panzoom;
}
if (typeof ($ as any).fn?.mousewheel !== 'function' && typeof _jq.fn?.mousewheel === 'function') {
  ($ as any).fn.mousewheel = _jq.fn.mousewheel;
}

@Component({
    selector: 'app-seat-plan',
    templateUrl: './seat-plan.component.html',
    styleUrls: ['./seat-plan.component.scss'],
    animations: [
        trigger('enabledStateChange', [
            state('default', style({
                opacity: 1,
            })),
            state('disabled', style({
                opacity: 0.5,
            })),
            transition('* => *', animate('300ms ease-out')),
        ])
    ],
    standalone: false
})
export class SeatPlanComponent implements OnInit, AfterViewInit {

  constructor(private loader: HttpLoaderService,
              private eventPlacementService: EventPlacementService,
              private cd: ChangeDetectorRef,
              private contingentService: ContingentService,
              private sanitizer: DomSanitizer,
              private convert: ConversionHelper,
              private dialog: MatDialog,
              public fileHelper: FileService,
              public seatPlanHelper: SeatPlanHelper,
              private translate: TranslateService) {
  }

  popoverDetailsLoading = false;
  reasonUnsellable = null;
  contingents: any = [];
  selectedSellableSection: any = {};
  selectedEventIds: any = [];
  priceCategories: any = [];
  selectedTicketType: any = {};
  selectedOrderLines = null;
  selectedPassePartouts = null;
  private contigentAdmin = false;
  public showContingents: boolean = false;
  selectedContingentId = -1;
  seatRestrictionTypes: any = [];
  availableContigents: any = [];
  selectedSeatRestrictionTypeId = -1;
  searching = false;
  selectedPositions: any = [];
  selectedPriceCategoryId = -1;
  popoverDetails = null;
  rows = [];

  seatPlan: any = {};

  @Output() onSelectionChange = new EventEmitter<object>();

  @Input()
  set section(s: any) {
    this.selectedSellableSection = s;
  }

  @Input()
  set ticketType(t: any) {
    this.selectedTicketType = t;
  }

  @Input()
  set eventIds(e: any) {
    this.selectedEventIds = e;
  }

  @Input()
  set orderlineSelection(e: any) {
    this.selectedOrderLines = e;
  }

  @Input()
  set passePartouts(e: any) {
    this.selectedPassePartouts = e;
  }


  ngOnInit() {
    this.Initialize();
  }

  reselectEarlierSelection() {

    let isSelected: boolean;
    let epsSelected: string | any[];
    let ols: any[];
    //this method selects the earlier selected seats again.
    let i: number;
    //But since the events/passepartouts can potentially be changes
    let ep: { Row: any; Column: any; };
    //we need to take  the lowest common denominator
    this.selectedEndpoints = [];


    if (this.selectedEventIds == null || this.selectedEventIds.length === 0 || this.selectedOrderLines == null) return;

    //we need the items that are selected in ALL events and or passepartouts
    //get the selection of the first (and random) event/pp.
    //Check if the seat is selected for all events/pps
    if (this.selectedPassePartouts != null && this.selectedPassePartouts.length > 0) {
      //when we have an pp selected, this has the prio
      const olsByPP = this.findByPassePartout(this.selectedOrderLines, this.selectedPassePartouts[0].Id);

      for (let ol of olsByPP) {
        ep = this.findEndPoint(ol.Row, ol.Column);
        if (ep != null) this.selectedEndpoints.push(ep);
      }

      for (let pp of this.selectedPassePartouts) {

        //iterate in reverse and check if the items is available for this event.
        i = this.selectedEndpoints.length;

        while (i--) {

          ep = this.selectedEndpoints[i];

          //now check every orderline for every event to see if the endpoint is also selected here
          ols = this.findByPassePartout(this.selectedOrderLines, pp.Id);

          epsSelected = ols.filter(function (ol) {
            if (ol.Row === ep.Row && ol.Column === ep.Column) return ol;
          });

          isSelected = epsSelected.length > 0;

          if (isSelected == false) {
            this.selectedEndpoints.splice(i, 1);
          }

        }
      }
    } else {

      const olByEvent = this.findByEvent(this.selectedOrderLines, this.selectedEventIds[0]);

      for (let ol of olByEvent) {
        ep = this.findEndPoint(ol.Row, ol.Column);
        if (ep != null) this.selectedEndpoints.push(ep);
      }

      for (let eId of this.selectedEventIds) {

        //iterate in reverse and check if the items is available for this event.
        i = this.selectedEndpoints.length;

        while (i--) {

          ep = this.selectedEndpoints[i];

          //now check every orderline for every event to see if the endpoint is also selected here
          ols = this.findByEvent(this.selectedOrderLines, eId);

          epsSelected = ols.filter(function (ol) {
            if (ol.Row === ep.Row && ol.Column === ep.Column) return ol;
          });

          isSelected = epsSelected.length > 0;

          if (isSelected == false) {
            this.selectedEndpoints.splice(i, 1);
          }
        }
      }
    }
  }

  findByPassePartout(ols, ppId) {
    return ols.filter(function (ol) {
      if (ol.PassePartoutId === ppId) return ol;
    });
  }

  findByEvent(ols, eventId) {
    return ols.filter(function (ol) {
      if (ol.EventId === eventId) return ol;
    });
  }

  findEndPoint(row, column) {
    for (let r of this.seatPlan.Rows) {
      for (let c of r.Columns) {
        if (c.Row == row && c.Column == column) {
          return c;
        }
      }
    }

    return null;
  }

  Initialize() {
    this.loader.open();

    const p: SectionAvailabilityArgs = {
      EventIds: this.selectedEventIds,
      ParentVBBId: this.selectedSellableSection.VenueBuildingBlockId,
      TicketTypeId: this.selectedTicketType.Id
    };

    this.contingentService.listSelectableContingents().subscribe((contingents: ContingentModel[]) => {
      this.contingents = contingents;
      this.eventPlacementService.getSection(p).subscribe((data) => {
        this.seatPlan = data;

        this.availableContigents = data.AvailableContingents;

        if (this.availableContigents === null) this.availableContigents = []

        this.availableContigents.unshift({
          Id: null,
          Name: this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.DROPDOWN.NO-CONTINGENT') == null ? '-' : this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.DROPDOWN.NO-CONTINGENT')
        });

        this.priceCategories = data.AvailablePriceCategories;

        this.seatRestrictionTypes = data.AvailableSeatRestrictions;
        if (this.seatRestrictionTypes === null)
          this.seatRestrictionTypes = [];

        this.seatRestrictionTypes.unshift({
          Id: null,
          Name: this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.DROPDOWN.NO-RESTRICTION') == null ? '-' : this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.DROPDOWN.NO-RESTRICTION')
        });


        this.initializeSeatPlan();
        this.reselectEarlierSelection();
        this.initializeSelectable();
        this.loader.close();
      });
    });
  }

  selectedEndpoints = [];
  searchedEndpoints = [];

  determineRowName(row) {

    let result = null;

    if (row == null || row.Columns == null || row.Columns.length == 0 || row.idx == 0) return ``;

    for (let col of row.Columns) {
      if (col.RowNumber != null && col.RowNumber != '') {

        //we found a row name
        if (result == null) result = col.RowNumber; //first one we found
        else if (result != col.RowNumber) {
          //we found one that doesn't match
          result += "*"; //indicates one or more differences
          return result;//and done
        }
      }
    }

    return result;
  }

  isItemSelected(endpoint, search = false) {
    let found: string | any[];
    if (!endpoint) return null;
    if (search) {
      if (this.searchedEndpoints == null && this.searchedEndpoints.length == 0)
        return false;

      found = this.searchedEndpoints.filter(function (ep) {
        if (ep.Id == endpoint.Id) return ep;
      });
    } else {
      if (this.selectedEndpoints == null && this.selectedEndpoints.length == 0)
        return false;

      found = this.selectedEndpoints.filter(function (ep) {
        if (ep.Id == endpoint.Id) return ep;
      });
    }

    return (found != null && found.length > 0);
  }

  clearSelection(search = false) {
    if (search) {
      this.searchedEndpoints = [];
      this.searching = false;
    } else {
      this.selectedEndpoints = [];
    }

    this.setSeatPlanProperties(true, search);
  }

  determineEntpointCssClass(ep) {

    if (ep == null) return '';


    let result = 'sp-h ';

    if (this.determineReasonUnsellable(ep) === null) {
      result += "sp-selectable "
    }

    if (ep.PlacementTypeId == -1) {
      //this happens when different events are selected and this seat has a different type
      //for the different events
      result += 'sp-indeterminate';
    } else if (ep.PlacementTypeId == 5) result += 's-fence'; //entrance
    else if (ep.PlacementTypeId == 4) result += 'endpoint-entrance'; //entrance
    else if (ep.PlacementTypeId == 3) result += 'invisible'; //no seat
    else if (ep.PlacementTypeId == 2) result += 's-stair'; //stairs

    else if (ep.PlacementTypeId == 1) {
      // //this is a seat, check the status of the seat
      // if (ep.Unavailable) result += 's-unavailable'; //unavailable seat
      // else if (ep.IsReserved) result += 's-reserved'; //reserved seat
      // else if (ep.IsSold === true) result += 's-taken'; //taken seat
      // else if (ep.IsAvailableForSale === false) result += 's-taken'; //not taken and not reserved but unavailable to this user (for instance, in contingent). Display as sold
      if (ep.SeatRestrictionId !== null) result += 's-rv'; //restricted view
      // else {
      //   result += 's-free'; //free seat
      // }
    }

    return result;
  }

  private debounceTimer;

  clearPopoverDetails() {

    if (this.debounceTimer !== null) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = null;
    }
  }

  fetchPopoverDetails(seatPlanPosition) {

    if (this.debounceTimer == null) {
      //display the spinner of the operation takes longer than a second
      this.debounceTimer = setTimeout(() => this.openDelayed(seatPlanPosition), 300);
    }
  }

  openDelayed(seatPlanPosition) {

    this.reasonUnsellable = this.determineReasonUnsellable(seatPlanPosition);

    const reload: boolean = (this.popoverDetails == null || !(this.popoverDetails.position.Row == seatPlanPosition.Row &&
      this.popoverDetails.position.Column == seatPlanPosition.Column));

    if (!reload) {
      return;
    }

    this.popoverDetailsLoading = true;
    this.popoverDetails = null;
    const args = {
      EventIds: undefined,
      ParentVBBId: this.selectedSellableSection.VenueBuildingBlockId,
      ticketTypeId: this.selectedTicketType.Id,
      Row: seatPlanPosition.Row,
      Column: seatPlanPosition.Column,
      ContigentAdmin: this.contigentAdmin,
      PassePartoutIds: undefined
    };
    if (this.selectedPassePartouts !== null && this.selectedPassePartouts.length > 0) {
      args.PassePartoutIds = this.selectedPassePartouts.map(x => x.Id);
    } else {
      args.EventIds = this.selectedEventIds;
    }
    this.eventPlacementService.getSeatPlanPositionDetails(args).subscribe((data) => {
      this.popoverDetails = {
        position: seatPlanPosition,
        details: data
      };
      this.popoverDetailsLoading = false;
    });
  }

  determineReasonUnsellable(seatPlanPos) {
    let result: string = null;

    if (seatPlanPos.ContingentId !== null && seatPlanPos.HasAccessToContingent === false) this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.REASON-UNSELLABLE.POSITION-UNAVAILABLE');
    if (seatPlanPos.IsSold) result = this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.REASON-UNSELLABLE.POSITION-SOLD');
    else if (seatPlanPos.IsReserved) result = this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.REASON-UNSELLABLE.POSITION-RESERVED');
    else if (seatPlanPos.IsAvailableForSale === false) result = this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.REASON-UNSELLABLE.POSITION-NOT-FOR-SALE');
    else if (seatPlanPos.IsUnavailable) result = this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.REASON-UNSELLABLE.POSITION-MARKED-UNAVAILABLE');
    else if (seatPlanPos.PlacementTypeId != 1) result = this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.REASON-UNSELLABLE.POSITION-NOT-A-SEAT');

    return result;
  }

  getStatusClass(details) {

    let result = 'status-dot ';

    if (details.ContingentName !== null && details.HasAccessToContingent === false) {
      result += 'status-dot-reserved';
    } else if (details.Unavailable || details.PlacementTypeId != 1) {
      result += 'status-dot-unavailable';
    } else if (details.Sold) {
      result += 'status-dot-not-available';
    } else if (details.Reserved) {
      result += 'status-dot-reserved';
    } else {
      result += 'status-dot-available';
    }

    return result;
  }

  getSeatNumber() {
    if (this.popoverDetails == null || this.popoverDetails.details == null || this.popoverDetails.details.PositionEventDetails == null || this.popoverDetails.details.PositionEventDetails.length == 0) return '-';
    return this.popoverDetails.details.PositionEventDetails[0].SeatNumber ? this.popoverDetails.details.PositionEventDetails[0].SeatNumber : '-';
  }

  getRowNumber() {
    if (this.popoverDetails == null || this.popoverDetails.details == null || this.popoverDetails.details.PositionEventDetails == null || this.popoverDetails.details.PositionEventDetails.length == 0) return '-';
    return this.popoverDetails.details.PositionEventDetails[0].RowNumber ? this.popoverDetails.details.PositionEventDetails[0].RowNumber : '-';
  }

  seatplanIsInitialized = false;

  initializeSelectable() {
    let updateOnlySelected = true;

    if (this.seatplanIsInitialized == false) {
      updateOnlySelected = false;
      this.seatplanIsInitialized = true;
    }
    //first up, determine all classes once
    this.setSeatPlanProperties(updateOnlySelected);

    ($(".seat-plan") as any).selectable({
      filter: '.sp-selectable',
      start: (event, ui) => {
        this.onSelectionStart(event, ui)
      },
      selected: (event, ui) => {
        this.onItemSelect(event, ui)
      },
      stop: (event, ui) => {
        this.onSelectionEnd(event, ui)
      }
    });
  }

  setSeatPlanProperties(onlyUpdateSelectable, search = false) {

    let rowIdx = 0;

    for (let row of this.seatPlan.Rows) {

      let colIdx = 0;

      row.rowName = this.determineRowName(row);

      for (let c of row.Columns) {

        // if (this.isItemSelected(ep)) {
        //   ep.selected =  += " ";
        // }
        if (search) {
          c.searched = this.isItemSelected(c, search);
        }
        c.selected = this.isItemSelected(c);

        if (onlyUpdateSelectable == false) {
          c.Classes = this.determineEntpointCssClass(c);
          c.SeatName = this.convert.namingForSeat(c, colIdx, rowIdx);
          c.artifectStyle = this.seatPlanHelper.getArtifactStyle(this.contingents, c.PlacementTypeId, c.IsSold, c.ContingentId, c.ReservationHexColor, c.AccessToContingent);
        }

        colIdx++;
      }
      rowIdx++;
    }

  }

  private inAlternateSelectionMode = false;
  private newSelectedEp: any[] = null;

  onSelectionStart(e, element) {
    this.cd.detach();
    this.newSelectedEp = [];
  }

  onItemSelect(e, element) {

    let ep: any = null;
    let id: number = +element.selected.id;


    //find the ep
    for (let r of this.seatPlan.Rows) {
      for (let c of r.Columns) {
        if (c.Id == id) {
          ep = c;
          break;
        }
      }
      if (ep !== null) break;
    }

    if (this.determineReasonUnsellable(ep) != null) return; //no need to select an unsellable item

    this.newSelectedEp.push(ep);
  }

  onSelectionEnd(e, element) {
    if (e.ctrlKey) this.inAlternateSelectionMode = true;

    if (this.newSelectedEp.length == 1) this.inAlternateSelectionMode = true;

    if (!this.inAlternateSelectionMode) this.clearSelection();

    for (let newEp of this.newSelectedEp) {
      if (this.isItemSelected(newEp)) {
        if (this.inAlternateSelectionMode) {
          //in this case unselect the item
          const idx = this.selectedEndpoints.indexOf(newEp);
          this.selectedEndpoints.splice(idx, 1);
        }
      } else {
        this.selectedEndpoints.push(newEp);
      }
    }

    this.inAlternateSelectionMode = false;
    this.newSelectedEp = [];
    this.clear();
    this.cd.reattach();
    this.cd.detectChanges();

    //last up, let the parent know about the change

    this.onSelectionChange.emit(this.selectedEndpoints);
  }

  showLegend() {


    let title = this.translate.instant('SALES.ORDERS.NEW.SEATPLAN.DIALOG.ROW-OFFSET.TITLE');
    let legendDialog: MatDialogRef<any> = this.dialog.open(SeatplanLegendComponent, {
      width: '400px',
      disableClose: true,
      data: {title: title}
    })

    legendDialog.afterClosed().subscribe(_ => {
    });
  }

  ngAfterViewInit() {


  }

  getCalculatedStyle() {
    let pageWidth = $('.page-holder').width();

    const style = 'max-width: ' + pageWidth + 'px';
    return this.sanitizer.bypassSecurityTrustStyle(style);
  }

  selectByProperty(prop, value, search, exclude) {
    let normalSearch = true;
    if (this.seatPlan.Rows == null) return;
    if (value == -1) return;
    // inverse search
    if (value === null) {
      normalSearch = false;
    }

    for (let r of this.seatPlan.Rows) {
      for (let c of r.Columns) {
        if (prop === 'PriceCategoryIds' && normalSearch === true) {
          if (c != null && c[prop] !== null && c.IsUnavailable === false) {
            for (let pcId of c[prop]) {

              if (pcId === value) {

                if (search && (c.searched === false || c.searched === undefined)) {
                  this.searchedEndpoints.push(c);
                }

                if (search === false && c.IsAvailableForSale === true && c.IsReserved === false && (c.selected === false || c.selected === undefined)) {
                  this.selectedEndpoints.push(c);
                }

              }
            }
          }
        } else {
          if (normalSearch === true) {
            if (c != null && c[prop] === value && c.IsUnavailable === false) {
              if (search && (c.searched === false || c.searched === undefined)) {
                this.searchedEndpoints.push(c);
              }
              if (search === false && (c.selected === false || c.selected === undefined) && c.IsAvailableForSale === true && c.IsReserved === false) {
                this.selectedEndpoints.push(c);
              }
            }
          } else {
            let add = true;
            delete exclude[0];
            exclude.forEach((element) => {
              if ((c != null && c[prop] === element.Id && c.IsAvailableForSale === true && c.IsReserved === false && c.IsUnavailable === false)) {
                add = false;
              }
            });
            if (add === true) {
              if (search === true && (c.searched === false || c.searched === undefined)) {
                this.searchedEndpoints.push(c);
              }
              if (search === false && (c.selected === false || c.selected === undefined)) {
                this.selectedEndpoints.push(c);
              }
            }
          }

        }

      }
    }
    if (this.searchedEndpoints.length > 0) {
      this.searching = search;
    }
    this.setSeatPlanProperties(true, search);
  }

  initializeSeatPlan() {
    setTimeout(() => {

      (function () {

          const $section = $('#focal');
          const $panzoomEl = $section.find('.panzoom-parent');

          const $panzoom = ($panzoomEl as any).panzoom({
            which: 3,
            cursor: "pointer",
          });

          // Manual right-click pan handler — panzoom's internal event binding
          // is unreliable with jQuery 3.7+ and modern browsers
          $panzoomEl.on('contextmenu.custompan', function (e) {
            e.preventDefault();
          });
          $panzoomEl.on('mousedown.custompan', function (e) {
            if ((e as any).which !== 3) return;
            e.preventDefault();
            (e as any).stopPropagation();

            const startX = (e as any).pageX;
            const startY = (e as any).pageY;
            const matrix = $panzoom.panzoom('getMatrix');
            const origX = +matrix[4];
            const origY = +matrix[5];

            $(document)
              .on('mousemove.custompan', function (moveEvt) {
                moveEvt.preventDefault();
                $panzoom.panzoom('pan',
                  origX + (moveEvt as any).pageX - startX,
                  origY + (moveEvt as any).pageY - startY,
                  { animate: 'skip' }
                );
              })
              .on('mouseup.custompan', function () {
                $(document).off('.custompan');
              });
          });

          $panzoom.parent().on('mousewheel.focal', function (e) {

            e.preventDefault();
            const delta = e.delta || e.originalEvent.wheelDelta;
            const zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;

            $panzoom.panzoom('zoom', zoomOut, {
              increment: 0.1,
              animate: false,
              focal: e
            });
          });

          let parentSelector = '#focal';

          const planWidth = $('.seat-plan').width();
          const planTop = $(parentSelector).offset().top;
          const planLeft = $(parentSelector).offset().left;
          const parentWidthFull = $(parentSelector).width();
          const parentWidth = parentWidthFull - 20; //we subtract 80 pixels from the parentwidth as we need some slack in the width

          const focal = {
            clientX: planLeft,
            clientY: planTop
          };

          let panX = 0;
          let panY = 0;

          if (parentWidth < planWidth) {
            //not enough room for the plan to show as a whole, zoom out.
            const scale = parentWidth / planWidth;

            $panzoom.panzoom("zoom", scale, {silent: true, focal: focal});

            //center the element, at this point easy, we just need to compensate for the padding of 20px
            panX = 10;
          } else {
            panX = 0; // the element itself is already centered.
          }

          panY = 30;

          $panzoom.panzoom("pan", panX, panY, {relative: true});

        }

      )();

    }, 50);
  }

  clear() {
    ($(".seat-plan") as any).selectable("destroy");
    this.initializeSelectable();
  }

  seeContigent() {
    this.contigentAdmin = true;
    this.showContingents = this.contigentAdmin;

  }

  lightUpChek(searched: boolean) {
    if (searched === true && this.searching === true) {
      return 'default';
    }

    if (!searched && this.searching) {
      return 'disabled';
    }

    return 'default';
  }
}
